import { render } from "./commonCookieGetPermission.vue?vue&type=template&id=38025a25&scoped=true&lang=pug"
import script from "./commonCookieGetPermission.vue?vue&type=script&lang=js"
export * from "./commonCookieGetPermission.vue?vue&type=script&lang=js"

import "./commonCookieGetPermission.vue?vue&type=style&index=0&id=38025a25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38025a25"]])

export default __exports__